



























































import PinPad from "@/components/PinPad.vue";
import { PinEventBus } from "@/store/Login";
import { handleError } from "@/lib/error-handling";
import { pause } from "@/lib/helpers";
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch
} from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";

export default defineComponent({
  components: {
    PinPad
  },
  setup() {
    const createdPin = ref("");
    const confirmedPin = ref("");
    const msg = ref(" ");
    const step = ref<"create" | "confirm" | "enter">("create");
    const { store } = useVuex();

    const enteredPin = computed({
      get: () => store.state.Login.pinDialogForm,
      set: store.commit.Login.setPinDialogForm
    });

    const dialog = computed({
      get: () => store.state.Login.pinDialog,
      set: (store.commit.Login as any).setPinDialogForm
    });

    const title = computed(() => {
      switch (step.value) {
        case "create":
          return "Choose a PIN code";
        case "confirm":
          return "Confirm PIN code";
        default:
          return "Enter PIN code";
      }
    });

    const persistent = computed(() => {
      return !!store.state.Login.pinDialogPersistent;
    });

    onMounted(() => {
      store.commit.Loading.stopLoading();
    });

    const createPin = () => {
      step.value = "confirm";
    };

    const confirmPin = async () => {
      if (createdPin.value && confirmedPin.value === createdPin.value) {
        try {
          await store.dispatch.Login.create(createdPin.value);
          await pause(200);
          enterPin(createdPin.value);
        } catch (error) {
          handleError(error, error);
        }
      } else {
        confirmedPin.value = "";
        msg.value = "PIN codes don't match";
        setTimeout(() => (msg.value = " "), 1500);
      }
    };

    const enterPin = (pin: string) => {
      PinEventBus.$emit("submit", pin);
    };

    const reset = () => {
      step.value = store.state.Login.pinCreated ? "enter" : "create";
      createdPin.value = "";
      confirmedPin.value = "";
    };

    watch(() => dialog.value, reset, { immediate: true, deep: true });

    return {
      createdPin,
      confirmedPin,
      msg,
      step,
      enteredPin,
      dialog,
      title,
      persistent,
      createPin,
      enterPin,
      reset,
      confirmPin
    };
  }
});
